import React from 'react';
import { Server, Database } from 'lucide-react';
import { useI18n } from '../i18n/i18n';
import HealthWidget from './HealthWidget';
import SummaryWidget from './SummaryWidget';

interface SystemInfoContainerProps {
  className?: string;
}

const SystemInfoContainer: React.FC<SystemInfoContainerProps> = ({ className = '' }) => {
  const { t } = useI18n();

  return (
    <div className={`bg-white rounded-lg shadow-sm border border-gray-200 ${className}`}>
      {/* Header */}
      <div className="border-b border-gray-200 px-6 py-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-r from-gray-500 to-slate-600 flex items-center justify-center">
            <Server className="h-5 w-5 text-white" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-gray-900">{t('systemInfo.title')}</h2>
            <p className="text-sm text-gray-500">{t('systemInfo.subtitle')}</p>
          </div>
        </div>
      </div>

      {/* System Widgets Grid */}
      <div className="p-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* System Health Widget */}
          <div className="bg-gray-50 rounded-lg p-1">
            <HealthWidget />
          </div>

          {/* Database Summary Widget */}
          <div className="bg-gray-50 rounded-lg p-1">
            <SummaryWidget />
          </div>
        </div>
      </div>

      {/* Footer Info */}
      <div className="border-t border-gray-200 px-6 py-3 bg-gray-50 rounded-b-lg">
        <div className="flex items-center justify-between text-xs text-gray-500">
          <span className="flex items-center space-x-2">
            <Database className="h-3 w-3" />
            <span>{t('systemInfo.footer.info')}</span>
          </span>
          <span>{t('systemInfo.footer.status')}</span>
        </div>
      </div>
    </div>
  );
};

export default SystemInfoContainer;